import React, { useState, useContext, useEffect } from "react";
import classNames from "classnames/bind";
import ListLocation from "./ListLocation";
import useFetchLocation from "../../../Location/useFetchLocation";
import Header from "../../../Location/Header";
import { DownIcon, LeftIcon } from "../../../../components/Icons/Icons";
import Filter from "../../../Location/Filter/Filter";
import { Button, Skeleton } from "../../../../components"; 
import SearchFail from "../../../Location/SearchFaild/SearchFail";
import styles from "../Tracing.module.css";
import { sorterArray } from "../../../../utils";
import { TracingEventContext } from "../../../../contexts";

const cx = classNames.bind(styles);
const SideBarManagerAI = ({ isVideoAI }) => {
  const { isApply, setIsApply,setListCheckApi,setListCodeCamera,setIsVideoAI } = useContext(TracingEventContext);
  const [isGroup, setIsGroup] = useState(true);
  const [filter, setFilter] = useState([]);
  const [value, setValue] = useState();
  const [listLocation, setListLocation] = useState([]);
  const [isFilter, setIsFilter] = useState(false);
  //eslint-disable-next-line
  const [isSearchFail, setIsSearchFail] = useState(false);
  const [groupCam, setGroupCam] = useState();
  const [provinceCode, setProvinceCode] = useState();
  const [haveVideo, setHaveVideo] = useState(0);
  // const [isVideoAI, setIsVideoAI] = useState(1);

  const handleShowWarehouse = (value) => {
    const data = listLocation.map((item, index) => {
      if (index === value) {
        return {
          ...item,
          isShow: !item.isShow,
          icon: !item.isShow ? <DownIcon /> : <LeftIcon />,
        };
      }
      return {
        ...item,
        isShow: false,
        icon: <LeftIcon />
      };
    });
    setListLocation(data);
  };
  const updateValue = (data) => {
    setValue(data);
  };
  const changeFilter = (data) => {
    setFilter(data);
  };
  const updateIsGroup = (data) => {
    setIsGroup(data);
    if(data !== isGroup){
      setListCheckApi([])
      setListCodeCamera([])
    }
  };
  const handleFilter = (data) => {
    setIsFilter(!isFilter);
    setFilter(data);
  };
  const handleApply = (e) => {
    setIsApply(!isApply);
  };

  const groups = useFetchLocation(
    "warehouse/get-list-group-warehouse-by-username/",
    "warehouse/get-list-province-warehouse-by-username/",
    isGroup,
    { value, provinceCode, groupCam, haveVideo, isVideoAI },
    // isApply
  );

  useEffect(() => {
    if (filter) {
      filter.forEach((item) => {
        switch (item.type) {
          case 'group':
            setGroupCam(item.name)
            break;
          case 'province':
            setProvinceCode(item.code)
            break;
          case 'status':
            if (item.code !== 'On' && item.code !== 'Off') {
              setHaveVideo(item.code)
            }
            break;
          default:
            return 0;
        }
      })
    }
  }, [filter])

  React.useEffect(() => {
    let value;
    if (isGroup) {
      value = groups.data?.map((item) => {
        return {
          code: item.GROUP_CODE,
          name: item.GROUP_NAME,
          wareHouses: item.LIST_WAREHOUSE,
          icon: <LeftIcon />,
          isShow: false,
        };
      });
    } else {
      value = groups.data?.map((item) => {
        return {
          code: item.PROVINCE_CODE,
          name: item.PROVINCE_NAME,
          wareHouses: item.LIST_WAREHOUSE,
          icon: <LeftIcon />,
          isShow: false,
        };
      });
    }
    if (value && value?.length > 0 && value[0].code) {
      const sortValue = sorterArray(value, 'name')
      setListLocation(sortValue);
    } else {
      setListLocation(value)
    }
  }, [groups.data, isGroup]);

  useEffect(() => {
    if(isVideoAI) {
      setFilter([{
        name: 'Có bản ghi',
        code: 1,
        type: 'status'
      }])
    }
  }, [isVideoAI])

  return (
    <div className={cx("list")}>
      {isFilter ? (
        <Filter onFilter={handleFilter} fillOn={'video'} setIsVideoAI={setIsVideoAI} />
      ) : (
        <>
          <Header
            value={value}
            setValue={updateValue}
            filter={filter}
            setFilter={changeFilter}
            handleFilter={handleFilter}
            isGroup={isGroup}
            setIsGroup={updateIsGroup}
            type="Tracing"
            setListCodeCamera={setListCodeCamera}
            setIsVideoAI={setIsVideoAI}
          />
          {groups.isLoading ? (
            <div className={cx("loading")}>
            <Skeleton height={48} width={"100%"} />
              <Skeleton height={48} width={"100%"} />
            </div>
          ) : (
            <div className={cx("list-location")}>
              {listLocation && listLocation?.length > 0 && !isSearchFail ? (
                listLocation.map((item, index) => {
                  if (item.wareHouses?.length >= 0) {
                    return (
                      <ListLocation
                        key={index}
                        indexLocation={index}
                        show={item.isShow}
                        onClick={handleShowWarehouse}
                        name={item.name}
                        wareHouses={item.wareHouses}
                        icon={item.icon}
                        code={item.code}
                        value={value}
                        isGroup={isGroup}
                        filter={filter}
                      />
                    );
                  }
                  return <React.Fragment key={index}></React.Fragment>;
                })
              ) : (
                <SearchFail />
              )}
            </div>
          )}
          {isApply && (
            <div className={cx("apply")}>
              <Button
                title="Áp dụng"
                className={cx("btn")}
                onClick={handleApply}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SideBarManagerAI;
